<template>
    <b-card>
        <change-orders-driver
            ref="bulkDriverModalRef"
            :orders="selectedOrders"
            @success="bulkDriverSuccess()"
        />

        <b-card-header>
            <b-container>
                <b-row>
                    <b-col cols="8">
                        <b-form-input
                            v-model="query"
                            placeholder="Order Search..."
                            type="search"
                            @input="updateQuery"
                        ></b-form-input>
                    </b-col>
                    <b-col>
                        <b-modal id="exportModal" title="Export">
                            <json-excel
                                class="btn btn-default"
                                :data="orders"
                                type="csv"
                                name="Export.xls"
                                :fields="efields"
                            >
                                Download CSV
                            </json-excel>
                        </b-modal>
                        <b-button-group class="float-right" size="sm">
                            <b-button variant="success" to="/admin/orders/0"
                                >Create New Order</b-button
                            >

                            <b-button v-b-modal.exportModal variant="primary">
                                Export
                            </b-button>

                            <b-button
                                variant="secondary"
                                @click="$emit('import')"
                                >Import</b-button
                            >
                        </b-button-group>
                    </b-col>
                </b-row>

                <b-row class="mt-4">
                    <b-col cols="2">
                        <b-button
                            variant="light"
                            size="sm"
                            @click="shouldShowFilters = !shouldShowFilters"
                        >
                            Filters
                            <i
                                class="fas"
                                :class="{
                                    'fas fa-chevron-down': !shouldShowFilters,
                                    'fas fa-chevron-up': shouldShowFilters,
                                }"
                            ></i>
                        </b-button>
                    </b-col>
                    <b-col cols="">
                        <order-date-range v-model="dateRangeIdx" />
                    </b-col>
                    <b-col cols="2">
                        <b-button
                            class="float-right"
                            size="sm"
                            :disabled="selectedOrders.length == 0"
                            @click="showBulkAction = true"
                            >Bulk Actions</b-button
                        >
                    </b-col>
                </b-row>

                <query-filter
                    :date-range="dateRangeIdx"
                    v-show="shouldShowFilters"
                    ref="queryFilter"
                    @input="filtersChanged"
                    :order-types="orderTypes"
                />
            </b-container>
        </b-card-header>

        <b-modal
            title="Select Action"
            class="pt-8"
            v-model="showBulkAction"
            hide-footer
        >
            <div class="text-center">
                <b-button
                    block
                    size="sm"
                    variant="primary"
                    :disabled="selectedOrders.length == 0"
                    @click="bulkSetDriver"
                    >Set Officer</b-button
                >

                <b-button
                    block
                    size="sm"
                    variant="info"
                    :disabled="selectedOrders.length == 0"
                    @click="bulkSetIncomplete"
                    >Set Incomplete</b-button
                >

                <b-button
                    block
                    size="sm"
                    variant="secondary"
                    :disabled="selectedOrders.length == 0"
                    @click="bulkRelease"
                    >Release Orders</b-button
                >

                <b-button
                    block
                    size="sm"
                    :disabled="selectedOrders.length == 0"
                    variant="warning"
                    @click="bulkDelete"
                    >Delete</b-button
                >

                <b-button
                    block
                    size="sm"
                    variant="default"
                    @click="showBulkAction = false"
                    >Exit</b-button
                >
            </div>
        </b-modal>
        <b-card-body>
            <p class="mt-3">
                Page: {{ pagination.page }} of {{ pageCount }} Total:
                {{ pagination.total }}
            </p>

            <b-table
                id="orderTable"
                :items="orders"
                :fields="fields"
                :busy="tableLoading"
                small
                striped
                selectable
                responsive
                @row-selected="onRowSelected"
                ref="selectableTable"
            >
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
                <!-- A custom formatted header cell for field 'name' -->
                <template #head(check)>
                    <b-form-checkbox
                        v-if="orders.length > 0"
                        :checked="orders.length === selectedOrders.length"
                        @change="toggleAllRow()"
                    ></b-form-checkbox>
                </template>

                <template #cell(check)="{ rowSelected, index }">
                    <b-form-checkbox
                        :checked="rowSelected"
                        @change="toggleRow(index, rowSelected)"
                    ></b-form-checkbox>
                </template>

                <template #cell(actions)="{ item }">
                    <b-button
                        size="sm"
                        :to="`/admin/orders/${item.id}`"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>

                <template #cell(id)="{ item }">
                    <h6>
                        <b-badge :variant="item | filterStatusVariant">{{
                            item | filterStatusName
                        }}</b-badge>
                    </h6>
                </template>

                <template #cell(custom_total)="{ value }">
                    <h6 class="pr-2" style="float: right">
                        {{ value | formatPrice }}
                    </h6>
                </template>

                <template #cell(tasks)="{ item }">
                    <h6>
                        <b-badge variant="info">
                            {{ item.completedTasks }} / {{ item.totalTasks }}
                        </b-badge>
                    </h6>
                </template>
            </b-table>

            <b-row>
                <b-col>
                    <b-pagination
                        class="float-right"
                        v-model="pagination.page"
                        :total-rows="pagination.total"
                        :per-page="pagination.pageSize"
                        aria-controls="customerTable"
                        pills
                        align="right"
                    ></b-pagination>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>
<script>
import JsonExcel from 'vue-json-excel'
import popupMixins from '@/mixins/popupMixins'
import moment from 'moment'
import _ from 'lodash'

//import autoTable from 'jspdf-autotable'
//import html2canvas from 'html2canvas'
import QueryFilter from './QueryFilter.vue'
import ChangeOrdersDriver from './ChangeOrdersDriver.vue'
import OrderDateRange from '@/components/OrderDateRange'

export default {
    name: 'order-table',
    components: {
        OrderDateRange,
        QueryFilter,
        ChangeOrdersDriver,
        JsonExcel,
    },
    mixins: [popupMixins],
    props: {
        type: {
            type: String,
        },
        title: String,
    },
    data() {
        return {
            showBulkAction: false,
            query: '',
            page: 1,
            shouldShowFilters: false,
            filters: {},
            bulkAction: 'none',

            dateRangeIdx: 2,
            selectedOrders: [],
            csvFields: {
                ID: 'id',
                'Reference ID': 'reference_id',
                'Customer Name': 'customer.name',
            },

            tableLoading: false,

            fields: [
                'check',
                'actions',
                {
                    key: 'reference_no',
                    label: 'Reference No',
                },

                {
                    key: 'id',
                    label: 'Status',
                },

                {
                    key: 'customer_id',
                    label: 'Customer',
                    formatter: (value, key, item) => item.customer.name,
                },
                'description',
                {
                    key: 'order_type_id',
                    label: 'Type',
                    formatter: (value, key, item) => item.type.name,
                },

                {
                    key: 'driver_id',
                    label: 'Officer',
                    formatter: (value, key, item) => {
                        const { first_name, last_name } = item.driver || {}
                        return `${first_name || ''} ${last_name || ''}`
                    },
                },
                {
                    key: 'custom_total',
                    label: 'Total',
                    formatter: (value, key, item) =>
                        item.items.reduce((_total, item) => {
                            const cost = item.quantity * item.price
                            const tax_cost = (cost * item.tax_rate) / 100
                            _total += cost + tax_cost
                            return _total
                        }, 0),
                },
                'tasks',
            ],

            efields: {
                ID: 'id',
                'Ref No': 'reference_no',
                'Created By': 'created_by.first_name',
                'Order Type': 'type.type',
                Customer: 'customer.name',
                'Item Type': 'item_type',
                'Item Name': 'item',
                Description: 'description',
                Quantity: 'items.quantity',
                Price: 'items.price',
                Tax: 'items.tax_rate',
                'Total Price': 'total_price',
                'Customer Signature': {
                    field: 'signature',
                    callback: value => (value === 1 ? 'YES' : 'NO'),
                },
            },
        }
    },

    filters: {
        formatPrice: function (value) {
            let val = (value / 1).toFixed(2).replace(',', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        filterStatusName(item) {
            return item.completed
                ? 'Completed'
                : item.warehouse_signed
                ? 'Processing'
                : 'Pending'
        },

        filterStatusVariant(item) {
            return item.completed
                ? 'success'
                : item.warehouse_signed
                ? 'primary'
                : 'danger'
        },
    },

    computed: {
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        orderTypes() {
            const orderTypes = this.$store.state.orderType.items
            console.log('orderTypes', orderTypes)
            return [{ name: 'Any', id: 0 }].concat(orderTypes)
        },

        orders() {
            const orders = this.$store.state.orders.items
            return orders
                .filter(x => {
                    if (this.filters.is_updated === 'any') return true
                    if (
                        this.filters.is_updated === 'changed' &&
                        x.created_at !== x.updated_at
                    )
                        return true
                    if (
                        this.filters.is_updated === 'notChanged' &&
                        x.created_at === x.updated_at
                    )
                        return true
                    return true //false
                })
                .map(x => {
                    x.driver = x.driver || {}
                    x.customer = x.customer || {}
                    x.warehouse = x.warehouse || {}
                    return x
                })
        },
        pagination() {
            return this.$store.state.orders.pagination || {}
        },
        dateObject() {
            return {
                today: {
                    created_start: moment().format('YYYY-MM-DD'),
                    created_end: moment().format('YYYY-MM-DD'),
                },
                yesterday: {
                    created_start: moment()
                        .subtract(1, 'days')
                        .format('YYYY-MM-DD'),
                    created_end: moment()
                        .subtract(1, 'days')
                        .format('YYYY-MM-DD'),
                },
                custom: {
                    created_start: '2020-01-01',
                    created_end: moment().format('YYYY-MM-DD'),
                },
            }
        },
        user() {
            return this.$store.state.user
        },
        officers() {
            return this.$store.state.users.all_users
        },
        permissions() {
            return this.$store.state.rolePermissions
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },
    watch: {
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        orders: {
            handler: function (x) {
                console.log('x', x.length)
                this.tableLoading = false
            },
            deep: true,
        },
        dateRangeIdx: function () {
            this.clearSelected()
        },
        filters: {
            handler({ created_start, created_end }) {
                if (
                    created_start === this.dateObject.today.created_start &&
                    created_end === this.dateObject.today.created_end
                ) {
                    this.dateRangeIdx = 0
                } else if (
                    created_start === this.dateObject.yesterday.created_start &&
                    created_end === this.dateObject.yesterday.created_end
                ) {
                    this.dateRangeIdx = 1
                } else {
                    this.dateRangeIdx = 2
                }

                this.doSearch()
            },
            deep: true,
        },
    },

    mounted() {
        this.$store.dispatch('orderType/fetchAll')
        this.$store.dispatch('users/fetchAll')
        //http://localhost:8080/#/orders?page=1&query=&changed=0&driver_id=0&customer_id=0&warehouse_id=0&completed=any&type=any&is_updated=any&created_start=2020-01-01&created_end=2020-09-16
        if (this.$route.query.query) this.query = this.$route.query.query
        if (this.$route.query.changed)
            this.filters.changed = this.$route.query.changed
        if (this.$route.query.driver_id)
            this.filters.driver_id = this.$route.query.driver_id
        if (this.$route.query.customer_id)
            this.filters.customer_id = this.$route.query.customer_id
        if (this.$route.query.warehouse_id)
            this.filters.warehouse_id = this.$route.query.warehouse_id
        if (this.$route.query.completed)
            this.filters.completed = this.$route.query.completed
        if (this.$route.query.type) this.filters.type = this.$route.query.type
        if (this.$route.query.is_updated)
            this.filters.is_updated = this.$route.query.is_updated
        if (this.$route.query.created_start)
            this.filters.created_start = this.$route.query.created_start
        if (this.$route.query.created_end)
            this.filters.created_end = this.$route.query.created_end
        this.doSearch()
    },
    methods: {
        onRowSelected(items) {
            this.selectedOrders = items
        },
        selectAllRows() {
            this.$refs.selectableTable.selectAllRows()
        },
        clearSelected() {
            this.$refs.selectableTable.clearSelected()
        },
        toggleRow(index, rowSelected) {
            // Rows are indexed from 0, so the third row is index 2
            if (rowSelected) this.$refs.selectableTable.unselectRow(index)
            else this.$refs.selectableTable.selectRow(index)
        },

        toggleAllRow() {
            if (this.orders.length === this.selectedOrders.length)
                this.$refs.selectableTable.clearSelected()
            else this.$refs.selectableTable.selectAllRows()
        },

        ////////////////////////////////

        checkKeyType(key) {
            switch (key) {
                case 'created_at':
                case 'updated_at':
                case 'schedule_at':
                case 'completed_at':
                    //case 'warehouse_datetime':
                    return 'date'
                case 'completed':
                case 'completed_by':
                    return 'bool'
                case 'driver_id':
                case 'warehouse_id':
                case 'description':
                case 'address':
                case 'signature':
                case 'warehouse_signed':
                case 'warehouse_signee':
                case 'signee':
                case 'reference_no':
                case 'total_price':
                default:
                    return null
            }
        },

        bulkSetDriver() {
            this.showBulkAction = false
            this.$refs.bulkDriverModalRef.show()
        },
        bulkDriverSuccess() {
            this.doSearch()
            this.clearSelected()
        },

        bulkRelease() {
            this.showBulkAction = false

            const title = 'Mark Orders as Released?'
            const message = `Are you sure you want to Release these orders?`
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    const orders = this.selectedOrders.map(x => x.id)
                    console.log('orders--tests', orders)
                    this.$store
                        .dispatch('orders/bulkRelease', { orders })
                        .then(() => {
                            this.doToast(
                                'Success!',
                                'Selected orders were Released',
                                'success'
                            )
                            this.clearSelected()
                            this.doSearch()
                        })
                        .catch(() => {
                            this.doToast(
                                'Error!',
                                'There was an Error Releasing Orders',
                                'danger'
                            )
                        })
                }
            })
        },

        bulkSetIncomplete() {
            this.showBulkAction = false

            const title = 'Mark Orders as Incomplete?'
            const message = `Include the Unrelease of Orders?`

            this.optionsMessage(title, message).then(results => {
                console.log('results', results)
                const { confirmed, optionSelected: unrelease } = results
                console.log('results', results)
                if (confirmed) {
                    const orders = this.selectedOrders.map(x => x.id)
                    this.$store
                        .dispatch('orders/bulkSetIncomplete', {
                            orders,
                            unrelease,
                        })
                        .then(() => {
                            this.doToast(
                                'Success!',
                                'Selected orders were marked as Incomplete',
                                'success'
                            )
                            this.clearSelected()
                            this.doSearch()
                        })
                        .catch(() => {
                            this.doToast(
                                'Error!',
                                'There was an error marking orders as incomplete',
                                'danger'
                            )
                        })
                }
            })
        },
        bulkDelete() {
            this.showBulkAction = false

            const title = 'Delete Orders?'
            const message = `Are you sure you want to delete these orders?`

            this.confirmMessage(title, message).then(result => {
                console.log('result', result)
                if (result) {
                    this.$store
                        .dispatch('orders/bulkDelete', {
                            orders: this.selectedOrders,
                        })
                        .then(() => {
                            this.doToast(
                                'Success!',
                                'Selected orders were deleted',
                                'success'
                            )

                            this.doSearch()
                        })
                        .catch(err => {
                            console.error(err)
                            this.doToast(
                                'Error!',
                                'Error deleting selected orders',
                                'danger'
                            )
                        })

                    this.clearSelected()
                }
            })
        },

        applyBulkAction() {},

        updateQuery: _.debounce(function (query) {
            this.query = query
            this.$router.push({ query: { query: this.query } })
            this.doSearch()
        }, 200),
        changePage: function (page) {
            this.page = page
            this.$router.push({
                query: { page: page, query: this.query, ...this.filters },
            })
            this.clearSelected()
            this.doSearch()
        },
        doSearch(orderCreated) {
            if (orderCreated) {
                this.dateRangeIdx = 0
            }
            const $this = this
            const { query, filters, page } = this
            this.$nextTick(() => {
                $this.tableLoading = true
                $this.$store.dispatch('orders/fetch', {
                    query,
                    filters,
                    page,
                })
            })
        },
        filtersChanged(filters) {
            console.log('filters', filters)
            this.filters = filters
            this.doSearch()
        },

        currency(num) {
            return num //.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        },
    },
}
</script>
<style></style>
